import PropTypes from 'prop-types';
import React from 'react';

function ToggleSelectionButtons(props) {

    const childButtons = React.Children.map(props.children,
        (child) => {

            if (!child) {
                return null;
            }

            let childClassName = child.props.className ? child.props.className : ''
            childClassName += (child.props.target === props.activeKey ? ' active' : '')
            childClassName += (props.buttonDisabled ? ' disabled' : '')

            return React.cloneElement(child, {
                onClick: (e) => {
                    props.onButtonClick(child.props.target)
                },
                className: childClassName,
                key: child.props.target,
                selected: child.props.target === props.activeKey
            });
        }
    )

    return (

        <div className="toggle-selection__buttons">
            {childButtons}
        </div>

    )

}

ToggleSelectionButtons.propTypes = {
    onButtonClick: PropTypes.func,
    activeKey: PropTypes.string
};

export default ToggleSelectionButtons


/** WEBPACK FOOTER **
 ** ./src/containers/util/ToggleSelectionButtons.js
 **/